import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const gmpPutEditApproversWorkflow = createApi(`GMPEditApproversWorkflowSlice`,"PUT");

const GMPEditApproversWorkflowSlice = createSlice({
  name: 'GMPEditApproversWorkflowSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gmpPutEditApproversWorkflow.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gmpPutEditApproversWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(gmpPutEditApproversWorkflow.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPEditApproversWorkflowSlice.reducer;